import { RefAttributes } from 'react';
import { Link as ReactRouterLink, LinkProps } from 'react-router';
import { classNames } from '@utils/classNames';

export function Link(props: LinkProps & RefAttributes<HTMLAnchorElement>) {
  return (
    <ReactRouterLink
      {...props}
      className={classNames(props.className, 'text-center')}
    ></ReactRouterLink>
  );
}
